import { getUserReservations } from '../../../../../ui-kitchen/src/api/api';
import { reservationsTransform } from '../../../../../ui-kitchen/src/api/resyApiTransformer';
import { getTranslation } from '../../../../../ui-kitchen/src/providers/TranslationProvider';
import Logger from '../../../../../ui-kitchen/src/utils/logger';

const TERMS_OF_USE = 'terms_of_use';
const PRIVACY_POLICY = 'privacy_policy';
const LEGAL_AGREEMENT = 'legal_agreement';
const LEGAL_AGREEMENT_PARTNER = 'legal_agreement_partner';

const escapeHtmlAttribute = (value = '') => String(value).replace(/"/g, '&quot;');

const getExternalLink = (url, label) => {
  const escapedUrl = escapeHtmlAttribute(url);
  return `<a href="${escapedUrl}" target="_blank">${label}</a>`;
};

const getDefaultLegalText = () => {
  const terms = getTranslation({ translationKey: TERMS_OF_USE });
  const privacy = getTranslation({ translationKey: PRIVACY_POLICY });
  const legalText = getTranslation({
    translationKey: LEGAL_AGREEMENT,
    translationValues: {
      termsOfUse: getExternalLink('https://resy.com/terms', terms),
      privacyPolicy: getExternalLink('https://resy.com/privacy', privacy),
    },
  });
  return legalText;
};

const getPartnerLegalText = ({ privacy_policy: partnerPrivacyUrl, terms_of_service: partnerTermsUrl }) => {
  const terms = getTranslation({ translationKey: TERMS_OF_USE });
  const privacy = getTranslation({ translationKey: PRIVACY_POLICY });
  const legalText = getTranslation({
    translationKey: LEGAL_AGREEMENT_PARTNER,
    translationValues: {
      termsOfUse: getExternalLink('https://resy.com/terms', terms),
      privacyPolicy: getExternalLink('https://resy.com/privacy', privacy),
      partnerTermsOfUse: getExternalLink(partnerTermsUrl, terms),
      partnerPrivacyPolicy: getExternalLink(partnerPrivacyUrl, privacy),
    },
  });
  return legalText;
};

const getLegalText = (venue) => {
  const partnershipBranding = venue.source?.logo ? venue.source : null;
  return partnershipBranding ? getPartnerLegalText(venue.source) : getDefaultLegalText();
};

const parsePaymentMethodId = (response) => {
  const { currentTarget: { value } } = response;
  return parseInt(value, 10);
};

const getSpecs = (time, partySize, type) => ({
  formattedDateTime: moment(time).calendar(null, {
    sameDay: 'llll',
    nextDay: 'llll',
    nextWeek: 'llll',
    sameElse: 'llll',
  }),
  day: moment(time).format('YYYY-MM-DD'),
  time: moment(time).format('HH:mm:ss'),
  partySize,
  tableType: type,
});

const handleError4121019 = (props) => {
  const {
    backPath, clearMessages, errorBook, navigate, resetBookingError, setMessages,
  } = props;
  setMessages([{
    ...errorBook.data,
    onClick: () => {
      resetBookingError();
      clearMessages();
      navigate(backPath);
    },
  }]);
};

const handleError412 = (props) => {
  const {
    errorBook, resetBookingError, setMessages,
  } = props;
  const {
    data: {
      specs: {
        reservation_id: reservationId,
      } = {},
    } = {},
  } = errorBook;
  if (!reservationId) {
    return;
  }
  getUserReservations()
    .then((response) => {
      const reservationsPayload = reservationsTransform(response);
      const reservation = reservationsPayload.find((resy) => resy.id === reservationId);
      setMessages([{
        data: reservation,
        status: 412,
        onClick: () => {
          resetBookingError();
        },
      }]);
    })
    .catch((e) => {
      Logger.error(e);
    });
};

const handleError402 = (props) => {
  const {
    navigate, resetBookingError, setMessages,
  } = props;
  setMessages([{
    message: 'Payment Method is Required',
    onClick: () => {
      navigate('/add-payment');
      resetBookingError();
    },
  }]);
};

const handleError400 = (props) => {
  const {
    clearMessages, errorBook, resetBookingError, setMessages,
  } = props;
  setMessages([{
    ...errorBook,
    onClick: () => {
      clearMessages();
      resetBookingError();
    },
  }]);
};

const handleError303 = (props) => {
  const { errorBook, setMessages } = props;
  setMessages([{ ...errorBook }]);
};

const handleErrorGeneric = (props) => {
  const {
    backPath,
    errorBook,
    navigate,
    resetBookingError,
    setMessages,
  } = props;
  const { message } = errorBook;
  setMessages([{
    message: (typeof message === 'string' && message?.length && message) || getTranslation({ translationKey: 'book_error_generic' }),
    onClick: () => {
      resetBookingError();
      navigate(backPath);
    },
  }]);
};
const handleBookingError = (props) => {
  const {
    errorBook,
  } = props;
  if (!errorBook) {
    return;
  }
  const status = errorBook?.status;
  const code = errorBook?.code;
  if (status === 412 && code === 1019) {
    handleError4121019(props);
  } else if (status === 412) {
    handleError412(props);
  } else if (status === 402) {
    handleError402(props);
  } else if (status === 400) {
    handleError400(props);
  } else if (status === 303) {
    handleError303(props);
  } else {
    handleErrorGeneric(props);
  }
};

const handleErrorOnLoad = (data, setMessages) => {
  if (!data) { return; }
  if (data?.response?.status === 303) {
    handleError303({ errorBook: data, setMessages });
  }
};

export {
  getDefaultLegalText,
  getLegalText,
  getPartnerLegalText,
  getSpecs,
  handleBookingError,
  handleErrorOnLoad,
  parsePaymentMethodId,
};
